export const successMessage = 'Password updated successfully.';
export const passwordsDontMatch = 'Passwords do not match. Please try again.';
export const passwordStrength = 'New password not strong enough.';
